import { useSelector } from "react-redux";
import { deleteStockInput, selectState, selectStockInputForDelete, setDeleteInputModalOpen } from "../inputSlice";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";

const DeleteRowModal = () => {
  const stockInput = useSelector(selectStockInputForDelete);
  const { deleteInputModalOpen } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteInputModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      if (stockInput) {
        dispatch(deleteStockInput(stockInput.inputId));
        toast.success("Uspešno obrisan.");
        close();
      }
    } catch (status) {
      toast.error("Greška prilikom brisanja.");
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={deleteInputModalOpen}
      title="Brisanje reda"
    >
      <p className="info-msg">
        Ovde brišete aktuelni red. Sledeći korak ne može se vratiti nazad!
      </p>
    </Modal>
  );
};

export default DeleteRowModal;
